var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewchat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 4.5H5.625C5.02826 4.5 4.45597 4.73705 4.03401 5.15901C3.61205 5.58097 3.375 6.15326 3.375 6.75V21.375C3.375 21.9717 3.61205 22.544 4.03401 22.966C4.45597 23.3879 5.02826 23.625 5.625 23.625H20.25C20.8467 23.625 21.419 23.3879 21.841 22.966C22.2629 22.544 22.5 21.9717 22.5 21.375V13.5",
    stroke: "#028383",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8125 3.93748C21.2606 3.49251 21.8668 3.24328 22.4983 3.24439C23.1298 3.24549 23.7351 3.49684 24.1816 3.94337C24.6281 4.38991 24.8795 4.99522 24.8806 5.62671C24.8817 6.2582 24.6325 6.86439 24.1875 7.31248L13.5 18L9 19.125L10.125 14.625L20.8125 3.93748Z",
    stroke: "#028383",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewchat);
export default __webpack_public_path__ + "static/media/newchat.b2307aae0d1128daf1b0ba77c717be03.svg";
export { ForwardRef as ReactComponent };